import script from "./GoalForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoalForm.vue?vue&type=script&lang=ts&setup=true"

import "./GoalForm.vue?vue&type=style&index=0&id=1d78a3a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d78a3a0"]])

export default __exports__